// extracted by mini-css-extract-plugin
export var layout = "IndexLayout-module--layout--abd2d";